.progress-control-container {
  font-size: 1.5em;
  line-height: 1.6;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  width: 100%;
  min-width: 40px;
  height: 16px;
  margin-inline: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.progress-control-container:focus .progress-knob {
  display: block !important;
  transform: scale(1.5);
}

.progress-control {
  position: relative;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  height: 2px;
}

.progress-control:after {
  animation: 3s cubic-bezier(1, 0, 1, 1) 0s 1 forwards fade-out;
}

@keyframes fade-out {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.hover-progress {
  position: absolute;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
}

.play-progress {
  position: absolute;
  height: 100%;
  background-color: var(--rds-accent-color);
}

.progress-knob {
  position: absolute;
  width: 13px;
  height: 13px;
  background-color: var(--rds-accent-color);
  right: -13px;
  margin: 7px;
  border-radius: 50%;
  top: -13px;
}

.mouse-time {
  position: absolute;
  bottom: 20px;
  color: var(--rds-foreground-primary);
}

@media (hover: hover) {
  .progress-control-container:hover .mouse-time:after {
    bottom: 0;
    right: min(var(--program-title-offset), -24px);
    min-width: 7ch;
    text-align: center;
  }

  .progress-control-container:hover .progress-control:after {
    right: 0;
    bottom: 11px;
  }

  .progress-control-container:hover .mouse-time:after,
  .progress-control-container:hover .progress-control:after {
    position: absolute;
    content: attr(data-tooltip);
    z-index: 1;
    border-radius: 2px;
    padding: 5px 12px;
    margin-right: -10px;
    font-size: 1rem;
    line-height: 1.4;
    font-weight: 600;
    white-space: nowrap;
    opacity: 1;
  }
}

.progressbar-time {
  display: flex;
  user-select: none;
}

.progressbar-total-time {
  @media (max-width: 400px) {
    display: none;
  }
}

.progressbar-time-wrapper {
  white-space: nowrap;
}

.no-cursor {
  cursor: none;
}
